<!-- eslint-disable vue/no-unused-properties -->
<script setup lang="ts">
import { Field as VeeField } from 'vee-validate';
import { InputOptions, BaseInputField } from '@/interfaces/InputFields';

const model = defineModel();

defineProps<
  BaseInputField & {
    autofocus?: boolean;
    disabled?: boolean;
    valid: boolean;
    centered?: boolean;
    inline?: boolean;
    labelPosition?: string;
  }
>();
</script>

<template>
  <fieldset
    class="Field"
    :class="[
      `Field--${type}`,
      {
        'Field--inline': inline,
        'Field--no-label': centered,
        'Field--invalid': !valid,
        'Field--inline--label-right': inline && labelPosition && labelPosition === 'right',
      },
    ]"
  >
    <vee-field
      v-for="(option, index) in options as InputOptions[]"
      :key="index"
      v-slot="{ field }"
      v-model="model"
      :name="name"
      type="button"
      :value="option.value"
    >
      <label
        class="Field__label--choice"
        :class="[
          `Field__label--choice--${type}`,
          `${inline ? '' : 'tw-w-full'}`,
          {
            'Field__label--choice--disabled': disabled,
            'Field__label--choice--checked': modelValue === option.value,
          },
        ]"
      >
        <input
          v-bind="field"
          :id="`${name}-${option.value}`"
          v-model="model"
          type="radio"
          :value="option.value"
          :checked="modelValue === option.value"
        />
        {{ option.label }}
      </label>
    </vee-field>
  </fieldset>
</template>
